import Box from '@mui/material/Box';
import { useEffect, useState } from 'react';
import { GadgetDaoFactory } from '../Home/components/gadgets/GadgetRepository';
import { FileType, createResourceEndpointUrl } from '../../helper/utils';
import DefaultGadgetIcon from "../../images/DefaultGadgetIcon.svg";
import { FlattenedGadget, Gadget, getFlattenedGadget } from '../../models/GadgetModel';
import styles from "./css/index.module.css";
import { useQuery } from 'react-query';
import { GadgetDetailsSection } from './components/GadgetDetailsSection';
import { useParams } from 'react-router-dom';
import Spinner from '../../components/Loader/Spinner';
import { ErrorBox } from '../../components/ErrorBox';
import { KeycloakClientFactory } from '../../helper/keycloak/factory';
import { useAppSelector } from '../../common/state/hooks';

declare const genv: any;

const GadgetDetails = () => {
  const keycloak = KeycloakClientFactory.getInstance();
  const isAuthenticated = useAppSelector((state) => state.auth.authenticated);
  const [displayGadget, setDisplayGadget] = useState<FlattenedGadget>();
  const [iconFile, setIconFile] = useState<string>("");
  const [provider, setProvider] = useState<string>(genv.ONLINE_DEFAULT_GROUP);
  const { id } = useParams();

  const getByGadgetId = (gadgetId: string | undefined) => {
    const parsedId: number = gadgetId ? parseInt(gadgetId, 10): 0;
    return GadgetDaoFactory.getGadgetRepository()
      .getByGadgetId(parsedId, provider)
      .then((result) => {
        const flattenedGadget = getFlattenedGadget(result);
        if(flattenedGadget.icon) {
          const iconUrl = createResourceEndpointUrl(flattenedGadget.id, flattenedGadget.version, flattenedGadget.platform, FileType.ICON, flattenedGadget.icon);
          flattenedGadget.icon = iconUrl;
          setIconFile(iconUrl);
        } else {
          setIconFile(DefaultGadgetIcon);
          flattenedGadget.icon = DefaultGadgetIcon;
        }
        setDisplayGadget(flattenedGadget);
        return result;
      });
  };

  useEffect(() => {
    if(isAuthenticated){
      const userData = keycloak.getIdToken();
      setProvider(userData.groups[0].name);
    }
  }, [isAuthenticated, keycloak]);

  const { isError, isLoading } = useQuery<Gadget,Error>([provider],() => getByGadgetId(id));

  return (
    <>
      <Box className={styles.container}>
        {
          isLoading ? <Spinner /> 
          : 
            isError 
              ? <Box className={styles.errorBoxContainer} data-testid="error-box-for-gadget-data">
                  <ErrorBox description={`No Agent Found with ID: ${id}`}/>
                </Box> 
            : displayGadget && <GadgetDetailsSection displayGadget={displayGadget} iconFile={iconFile}/>
        }
      </Box>
    </>
  );
};

export default GadgetDetails;